import React from 'react';
import PropTypes from 'prop-types';

import {Box} from '@salesforce/retail-react-app/app/components/shared/ui';

export function isFieldRequired(rules) {
  if (!rules || typeof rules !== 'object') {
    return false;
  }

  const {required} = rules;

  return required === true || (typeof required === 'string' && required.length > 0);
}

export function appendRequiredAsterisk(label) {
  if (!label || typeof label !== 'string') {
    return label;
  }

  if (/\*$/.test(label.trim())) {
    return label;
  }

  return `${label}*`;
}

export function resolveRequiredPlaceholder(placeholder, label, isRequired) {
  const base = placeholder || label;

  if (!isRequired) {
    return base;
  }

  return appendRequiredAsterisk(base);
}

export function isFloatingLabelVisible({isFocused, value, isDisabled}) {
  return Boolean(
    isFocused ||
    (value != null && value.toString().trim() !== '') ||
    isDisabled
  );
}

/**
 * Floating-label fields: * on placeholder only when label is hidden (empty resting).
 * When label is floated, * stays on the label to avoid duplicate markers.
 */
export function resolveFloatingFieldPlaceholder({
  placeholder,
  label,
  isRequired,
  isLabelVisible,
  isCheckoutPayment = false,
}) {
  const base = isCheckoutPayment ? placeholder : (placeholder || label);

  if (!base) {
    return base;
  }

  if (isRequired && !isLabelVisible) {
    return appendRequiredAsterisk(base);
  }

  return base;
}

export function FieldLabelContent({label, required, rules}) {
  const isRequired = required ?? isFieldRequired(rules);

  if (!label) {
    return null;
  }

  return (
    <>
      {label}
      {isRequired ? (
        <Box as="span" aria-hidden="true" lineHeight="1">
          {'*'}
        </Box>
      ) : null}
    </>
  );
}

FieldLabelContent.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  required: PropTypes.bool,
  rules: PropTypes.object,
};
